import { mapState } from 'vuex'
import * as moment from 'moment'
import * as Sentry from '@sentry/vue'
import featuresByPlan from './featuresByPlan'
import featuresByPlanForSingaporean from './featuresByPlan.singapore'
import featuresByPlanForVietnamese from './featuresByPlan.vietnam'
import featuresByPlanForEur from './featuresbyPlan.eur'
import contentPlan from './contentPlan'
import {
} from '@/constant/slideTypes'
import config from '@/config'

const APPLIED_COUNTRIES = {
  VIET_NAM: 'vietnam',
  SINGAPORE: 'singapore',
  EUROPE: 'europe',
  AUSTRIA: 'austria',
  BELGIUM: 'belgium',
  CROATIA: 'croatia',
  CYPRUS: 'cyprus',
  ESTONIA: 'estonia',
  FINLAND: 'finland',
  FRANCE: 'france',
  GERMANY: 'germany',
  GREECE: 'greece',
  IRELAND: 'ireland',
  ITALY: 'italy',
  LATVIA: 'latvia',
  LITHUANIA: 'lithuania',
  LUXEMBOURG: 'luxembourg',
  MALTA: 'malta',
  NETHERLANDS: 'netherlands',
  PORTUGAL: 'portugal',
  SLOVAKIA: 'slovakia',
  SLOVENIA: 'slovenia',
  SPAIN: 'spain',
  DEFAULT: 'united states',
}

const CURRENCIES = {
  USD: 'usd',
  VND: 'vnd',
  SGD: 'sgd',
  EUR: 'eur',
}

const SUPPORTED_CURRENCIES = [
  CURRENCIES.EUR,
  CURRENCIES.USD,
  CURRENCIES.VND,
  CURRENCIES.SGD,
]

const CURRENCIES_COUNTRY_MAP = {
  [CURRENCIES.USD]: APPLIED_COUNTRIES.DEFAULT,
  [CURRENCIES.VND]: APPLIED_COUNTRIES.VIET_NAM,
  [CURRENCIES.SGD]: APPLIED_COUNTRIES.SINGAPORE,
  [CURRENCIES.EUR]: APPLIED_COUNTRIES.EUROPE,
}

const FEATURED_PLANS_COUTRY_MAP = {
  [APPLIED_COUNTRIES.VIET_NAM]: featuresByPlanForVietnamese,
  [APPLIED_COUNTRIES.SINGAPORE]: featuresByPlanForSingaporean,
  [APPLIED_COUNTRIES.EUROPE]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.AUSTRIA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.BELGIUM]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.CROATIA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.CYPRUS]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.ESTONIA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.FINLAND]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.FRANCE]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.GERMANY]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.GREECE]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.IRELAND]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.ITALY]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.LATVIA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.LITHUANIA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.LUXEMBOURG]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.MALTA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.NETHERLANDS]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.PORTUGAL]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.SLOVAKIA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.SLOVENIA]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.SPAIN]: featuresByPlanForEur,
  [APPLIED_COUNTRIES.DEFAULT]: featuresByPlan,
}

const FROM_JUST_NOW = {
  [APPLIED_COUNTRIES.VIET_NAM]: '200,000',
  [APPLIED_COUNTRIES.SINGAPORE]: '10.75',
  [APPLIED_COUNTRIES.EUROPE]: '7.25',
  [APPLIED_COUNTRIES.AUSTRIA]: '7.25',
  [APPLIED_COUNTRIES.BELGIUM]: '7.25',
  [APPLIED_COUNTRIES.CROATIA]: '7.25',
  [APPLIED_COUNTRIES.CYPRUS]: '7.25',
  [APPLIED_COUNTRIES.ESTONIA]: '7.25',
  [APPLIED_COUNTRIES.FINLAND]: '7.25',
  [APPLIED_COUNTRIES.FRANCE]: '7.25',
  [APPLIED_COUNTRIES.GERMANY]: '7.25',
  [APPLIED_COUNTRIES.GREECE]: '7.25',
  [APPLIED_COUNTRIES.IRELAND]: '7.25',
  [APPLIED_COUNTRIES.ITALY]: '7.25',
  [APPLIED_COUNTRIES.LATVIA]: '7.25',
  [APPLIED_COUNTRIES.LITHUANIA]: '7.25',
  [APPLIED_COUNTRIES.LUXEMBOURG]: '7.25',
  [APPLIED_COUNTRIES.MALTA]: '7.25',
  [APPLIED_COUNTRIES.NETHERLANDS]: '7.25',
  [APPLIED_COUNTRIES.PORTUGAL]: '7.25',
  [APPLIED_COUNTRIES.SLOVAKIA]: '7.25',
  [APPLIED_COUNTRIES.SLOVENIA]: '7.25',
  [APPLIED_COUNTRIES.SPAIN]: '7.25',
  [APPLIED_COUNTRIES.DEFAULT]: '7.95',
}

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      planUser: (state) => state.currentUser.plan,
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    fromJustNow() {
      return FROM_JUST_NOW[this.appliedCountry]
    },
    isUserRegisterBeforeGoLivePricingOrPlanUser() {
      try {
        if (!this.currentUser.myPlan) {
          return false
        }
        const activeSub = this.currentUser.myPlan.subscription
        // if user have active sub and currency is eur  => new flow pricing
        if (activeSub.currency === 'eur') {
          return false
        }
        // if user have active sub and created time sub before time go live => old flow pricing
        if (
          activeSub &&
          moment(activeSub.created).isBefore(config.timeGoLivePricing)
        ) {
          return true
        }
        return false
      } catch (e) {
        Sentry.captureException(e)
        return true
      }
    },

    featuresByPlan() {
      const features = FEATURED_PLANS_COUTRY_MAP[this.appliedCountry]
      return this.mergePlans(features, contentPlan)
    },
    appliedCountry() {
      const isSupportedCurrency = SUPPORTED_CURRENCIES.includes(this.activeSubUserCurrency)
      if (this.activeSubUserCurrency && isSupportedCurrency) {
        return CURRENCIES_COUNTRY_MAP[this.activeSubUserCurrency]
      }

      if (this.activeSubUserCurrency && !isSupportedCurrency) {
        return APPLIED_COUNTRIES.DEFAULT
      }

      const country = this.currentUser.country?.toLowerCase()
      if (Object.values(APPLIED_COUNTRIES).includes(country)) {
        return country
      }

      return APPLIED_COUNTRIES.DEFAULT
    },
    activeSubUserCurrency() {
      return this.activeSubUser?.currency?.toLowerCase()
    },
    activeSubUser() {
      return this.currentUser.myPlan && this.currentUser.myPlan.subscription
    },
    fullSymbolCurrency() {
      return this.featuresByPlan?.fullSymbolCurrency
    },
    symbolCurrency() {
      return this.featuresByPlan?.symbolCurrency
    },
  },
  methods: {
    isForPairPlan() {
      return false
    },
    addButtonVariant(planPrices) {
      return planPrices.map((plan) => {
        const buttonVariantMap = {
          Essential: 'essential',
          Pro: 'pro',
          Enterprise: 'primary',
          'Edu Small': 'essential',
          'Edu Medium': 'pro',
          'Edu Large': 'primary',
        }
        const buttonVariant = buttonVariantMap[plan.label]
        return {
          ...plan,
          buttonVariant,
        }
      })
    },
    mergePlans(features, content) {
      const merged = {}
      const planMapping = {
        annual: 'normal',
        monthly: 'normal',
        educational: 'educational',
      }

      Object.keys(features).forEach((planType) => {
        const contentType = planMapping[planType]

        if (
          features[planType] &&
          features[planType].planPrices &&
          content.card[contentType]
        ) {
          merged[planType] = {
            planPrices: features[planType].planPrices.map((plan) => {
              const matchingContent = content.card[contentType].find(
                (contentData) => contentData.column === plan.column,
              )
              return matchingContent ? { ...plan, ...matchingContent } : plan
            }),
          }
        }
      })

      return {
        ...merged,
        fullSymbolCurrency: features.fullSymbolCurrency,
        symbolCurrency: features.symbolCurrency,
        plansDropdown: content.plansDropdown,
        comparePlan: content.comparePlan,
      }
    },
    setTranslationforPlainText(text) {
      // Check if text is a number, boolean, or non-string
      if (typeof text === 'number' ||
          typeof text === 'boolean' ||
          typeof text !== 'string') {
        return text
      }
      // Check if the text can be converted to a valid number
      const num = Number(text)
      if (!Number.isNaN(num)) {
        return text
      }
      // If none of the above, return the translation
      return this.$i18nPresenter.t(text)
    },
  },
}
